import { acConfig } from '@ac/library-utils/dist/declarations';
import { RegionConfiguration } from '@ac/library-utils/dist/declarations/config/ac.config';

export const findRegionData = (
  regionCode: string
): RegionConfiguration | undefined =>
  acConfig.regions.find(
    (region) => region.code.toLowerCase() === regionCode.toLowerCase()
  );
